import { render, staticRenderFns } from "./viewTransfer.vue?vue&type=template&id=4f0d1e1d&scoped=true&"
import script from "./viewTransfer.vue?vue&type=script&lang=js&"
export * from "./viewTransfer.vue?vue&type=script&lang=js&"
import style0 from "./viewTransfer.vue?vue&type=style&index=0&id=4f0d1e1d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0d1e1d",
  null
  
)

export default component.exports